import React from 'react';
import PropTypes from "prop-types";
import { Alert, Button } from "flowbite-react";
import { FaBookOpen } from "react-icons/fa";
import { HiEye } from "react-icons/hi2";
import { KeywordsRegex, Suggestions } from "../utils/Constants";
import { testMatches, gaEvent } from "../utils/Utils";
import { useSearchContext } from "../utils/Context";
var Suggestion = function Suggestion(props) {
  var _useSearchContext = useSearchContext(),
    options = _useSearchContext.options,
    totalCount = _useSearchContext.totalCount;
  var _onClick = function onClick(name, query) {
    gaEvent("suggestion", {
      category: "Suggestion",
      label: name,
      value: query,
      nonInteraction: true
    });
  };
  if (props.query && options.showSuggestions) {
    var matches = Suggestions.filter(function (suggestion) {
      return testMatches(props.query, suggestion.matches);
    });
    if (matches.length) {
      var suggestionComponents = matches.map(function (suggestion, index) {
        var comments = "Looking for ".concat(suggestion.name, " information? Here is a resource that might help.");
        if (suggestion.hasOwnProperty("comments") && suggestion.comments.trim() !== "") {
          comments = suggestion.comments;
        }
        var color = "teal";
        if (suggestion.hasOwnProperty("color") && suggestion.color.trim() !== "") {
          color = suggestion.color;
        }
        var icon = FaBookOpen;
        if (suggestion.hasOwnProperty("icon") && suggestion.icon) {
          icon = suggestion.icon;
        }
        var additionalContent = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
          className: "mt-1 mb-3 text-sm"
        }, comments), /*#__PURE__*/React.createElement("div", {
          className: "flex flex-wrap items-center gap-2"
        }, /*#__PURE__*/React.createElement(Button, {
          href: suggestion.link,
          onClick: function onClick() {
            return _onClick(suggestion.name, props.query);
          },
          target: "_blank",
          color: color,
          size: "xs",
          pill: true
        }, /*#__PURE__*/React.createElement(HiEye, {
          className: "-ml-0.5 mr-2 h-4 w-4"
        }), " View more")));
        return /*#__PURE__*/React.createElement(Alert, {
          key: index,
          color: color,
          withBorderAccent: true,
          icon: icon,
          additionalContent: additionalContent,
          className: "shadow-md"
        }, /*#__PURE__*/React.createElement("h3", {
          className: "text-lg font-medium leading-tight"
        }, suggestion.name));
      });
      var gridColumns;
      switch (suggestionComponents.length) {
        case 2:
        case 4:
          gridColumns = 2;
          break;
        case 3:
          gridColumns = 3;
          break;
        default:
          gridColumns = 1;
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "gap-4 grid grid-cols-1 xl:grid-cols-".concat(gridColumns)
      }, suggestionComponents);
    }
  }
  return null;
};
Suggestion.propTypes = {
  query: PropTypes.string.isRequired
};
export default Suggestion;